import { AnyAri } from '@atlassian/ari/any-ari';
import { ConfluenceCommentAri } from '@atlassian/ari/confluence/comment';

import {
  type CommentContentType,
  mapCommentContentTypeToResourceType,
  ReactionsResourceType,
} from '../comment-types';
import { type CommentModel } from '../model';
import { getReactionsStore } from '../state/reactions-store';

export const fetchReactions = (
  cloudId: string,
  contentId: string,
  contentType: CommentContentType,
  comments: CommentModel[] = []
) => {
  const store = getReactionsStore();

  const resourceType =
    mapCommentContentTypeToResourceType(contentType) ?? ReactionsResourceType.whiteboard;

  if (!cloudId || !contentId || !store) {
    return;
  }

  const containerAri = AnyAri.create({
    resourceType: resourceType as ReactionsResourceType,
    resourceOwner: 'confluence',
    cloudId,
    resourceId: contentId,
  });

  comments.forEach((comment) => {
    const ari = ConfluenceCommentAri.create({
      commentId: comment.reactionsId,
      siteId: cloudId as string,
    });
    store.getReactions(containerAri.toString(), ari.toString());
  });
};
